export { getResourceName } from './getResourceName';
export { getRoleNameForTracking } from './getRoleNameForTracking';
export { readMembershipFragment } from './readMembershipFragment';
export { useReadMembershipFragment } from './useReadMembershipFragment';

export const INVITE_MESSAGE_MAX_LENGTH = 120;

export type InputToken = {
  id: string;
  status: InputTokenStatus;
  emoji?: string;
  label: string;
  avatarBackground?: string;
  avatarSrc?: string | string[];
  avatarNames?: string[];
  memberCount?: number;
  isClickable?: boolean;
  tooltip?: {
    title: string;
    details?: string;
  };
};

export enum InputTokenStatus {
  EXISTING_GROUP,
  EXISTING_GUEST,
  EXISTING_MEMBER,
  MEMBER,
  GROUP,
  INVALID_EMAIL,
  NEW_GUEST,
  NEW_MEMBER,
  NEW_MEMBER_WARN,
  DOWNGRADING_ADMIN,
  DOWNGRADING_OWNER,
  NEW_REVIEWER,
}
